import {useCallback, useEffect, useState} from 'react'
import {DataObjectId} from 'yougile-model'
import {multiActionsWithTasksStore as store} from './multi-actions-with-tasks-store'

export const useMultiActionsCheckbox = (
  columnId: DataObjectId
): {
  visible: boolean
  value: boolean | undefined
  onChange: (value: boolean) => void
} => {
  const [visible, setVisible] = useState(false)
  const [value, setValue] = useState<boolean | undefined>(false)

  useEffect(() => {
    if (!store.state.visible) {
      setVisible(false)
    } else {
      setVisible(true)
      setValue(store.allSelected(columnId))
    }
  }, [
    store.state.tasksIds.size,
    store.state.visible,
    // required dep to recalculate value after column tasks is updated in `setColumnTasks`
    store.state.columnTasks[columnId]
  ])

  const onChange = useCallback(
    (value: boolean) => store.setAllSelected(columnId, value),
    [store, columnId]
  )

  return {visible, value, onChange}
}
